import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import './style.scss';
import Shortcut from '@tekion/tekion-components/src/molecules/Accessibility/Shortcuts';
const Search = props => {
  const {
    handleOnChange,
    handleOnClick,
    isSearching,
    searchText
  } = props;
  const [placeholder, setPlaceholder] = useState(__('Press \'S\' to Search'));
  const focusInput = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: "search-container"
  }, /*#__PURE__*/React.createElement(Shortcut, {
    ordered: ['s'],
    onMatch: () => focusInput.current.focus()
  }), /*#__PURE__*/React.createElement("div", {
    className: "search-shortcut"
  }, /*#__PURE__*/React.createElement("span", {
    className: "search-shortcut-text"
  }, __('To open menu directly')), /*#__PURE__*/React.createElement("span", {
    className: "search-shortcut-text-padded"
  }, __('Cmd')), /*#__PURE__*/React.createElement("span", {
    className: "search-shortcut-text-padded"
  }, __('\\'))), /*#__PURE__*/React.createElement(Input, {
    ref: focusInput,
    autoFocus: true,
    onFocus: () => setPlaceholder(__('Search')),
    onBlur: () => setPlaceholder(__('Press \'S\' to Search')),
    placeholder: placeholder,
    onChange: handleOnChange,
    value: searchText,
    suffix: isSearching ? /*#__PURE__*/React.createElement("span", {
      onClick: handleOnClick,
      role: "button",
      className: "icon-cross"
    }) : /*#__PURE__*/React.createElement("span", {
      className: "icon-search-thick"
    })
  }));
};
Search.propTypes = {
  handleOnChange: PropTypes.func.isRequired
};
export default Search;